export interface PartnerOption {
  partnerCode: string;
  partnerName: string | null;
}

export interface PartnerGroup {
  letter: string;
  options: PartnerOption[];
}

export function partnerLabel(option: PartnerOption): string {
  return option.partnerName ?? option.partnerCode;
}

function compareOptions(a: PartnerOption, b: PartnerOption): number {
  return (
    partnerLabel(a).localeCompare(partnerLabel(b), "en", { sensitivity: "base" }) ||
    a.partnerCode.localeCompare(b.partnerCode)
  );
}

export function mergePartnerOptions(active: PartnerOption[], grants: PartnerOption[]): PartnerOption[] {
  const byCode = new Map<string, PartnerOption>();
  for (const option of [...active, ...grants]) {
    const existing = byCode.get(option.partnerCode);
    if (!existing || (!existing.partnerName && option.partnerName)) {
      byCode.set(option.partnerCode, option);
    }
  }
  return [...byCode.values()].sort(compareOptions);
}

export function filterPartnerOptions(options: PartnerOption[], query: string): PartnerOption[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return options;
  return options.filter(
    (o) => o.partnerCode.toLowerCase().includes(needle) || (o.partnerName ?? "").toLowerCase().includes(needle),
  );
}

export function groupByInitial(options: PartnerOption[]): PartnerGroup[] {
  const groups: PartnerGroup[] = [];
  for (const option of options) {
    const first = partnerLabel(option).trim().charAt(0).toUpperCase();
    const letter = /[A-Z]/.test(first) ? first : "#";
    const last = groups[groups.length - 1];
    if (last && last.letter === letter) {
      last.options.push(option);
    } else {
      groups.push({ letter, options: [option] });
    }
  }
  return groups;
}

export function moveHighlight(current: number, delta: 1 | -1, count: number): number {
  if (count === 0) return -1;
  if (current < 0) return delta === 1 ? 0 : count - 1;
  return Math.min(count - 1, Math.max(0, current + delta));
}
